<template>
  <div :class="['wrapper', classes]">
    <header class="main-header row">
	<div class="col-sm-6 logo-mini">
		<a href="/"><img src="/static/img/logo.svg" alt="Logo" class="img-responsive center-block logo"></a>
		<!--img src="/static/img/vizeum_text.svg" alt="Logo" class="img-responsive center-block logo"-->
	</div>
	<div class="col-sm-6">
      <!-- Header Navbar -->
      <nav class="navbar navbar-static-top" role="navigation">
        <!-- Sidebar toggle button-->
        <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button" style="display:none">
          <span class="sr-only">Toggle navigation</span>
        </a>
        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">

          <ul class="nav navbar-nav">
            <!-- Messages-->
            <li class="dropdown messages-menu" style="display:none;">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <i class="fa fa-envelope-o"></i>
                <span class="label label-success">{{ userInfo.messages | count }}</span>
              </a>
              <ul class="dropdown-menu">
                <li class="header">You have {{ userInfo.messages | count }} message(s)</li>
                <li v-if="userInfo.messages.length > 0">
                  <!-- inner menu: contains the messages -->
                  <ul class="menu">
                    <li>
                      <!-- start message -->
                      <a href="javascript:;">
                        <!-- Message title and timestamp -->
                        <h4>
                          Support Team
                          <small>
                            <i class="fa fa-clock-o"></i> 5 mins</small>
                        </h4>
                        <!-- The message -->
                        <p>Why not consider this a test message?</p>
                      </a>
                    </li>
                    <!-- end message -->
                  </ul>
                  <!-- /.menu -->
                </li>
                <li class="footer" v-if="userInfo.messages.length > 0">
                  <a href="javascript:;">See All Messages</a>
                </li>
              </ul>
            </li>
            <!-- /.messages-menu -->

            <!-- Notifications Menu -->
            <li class="dropdown notifications-menu" style="display:none;">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <i class="fa fa-bell-o"></i>
                <span class="label label-warning">{{ userInfo.notifications | count }}</span>
              </a>
              <ul class="dropdown-menu">
                <li class="header">You have {{ userInfo.notifications | count }} notification(s)</li>
                <li v-if="userInfo.notifications.length > 0">
                  <!-- Inner Menu: contains the notifications -->
                  <ul class="menu">
                    <li>
                      <!-- start notification -->
                      <a href="javascript:;">
                        <i class="fa fa-users text-aqua"></i> 5 new members joined today
                      </a>
                    </li>
                    <!-- end notification -->
                  </ul>
                </li>
                <li class="footer" v-if="userInfo.notifications.length > 0">
                  <a href="javascript:;">View all</a>
                </li>
              </ul>
            </li>

            <!-- Tasks Menu -->
            <li class="dropdown tasks-menu" style="display:none;">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <i class="fa fa-flag-o"></i>
                <span class="label label-danger">{{ userInfo.tasks | count }} </span>
              </a>
              <ul class="dropdown-menu">
                <li class="header">You have {{ userInfo.tasks | count }} task(s)</li>
                <li v-if="userInfo.tasks.length > 0">
                  <!-- Inner menu: contains the tasks -->
                  <ul class="menu">
                    <li>
                      <!-- Task item -->
                      <a href="javascript:;">
                        <!-- Task title and progress text -->
                        <h3>
                          Design some buttons
                          <small class="pull-right">20%</small>
                        </h3>
                        <!-- The progress bar -->
                        <div class="progress xs">
                          <!-- Change the css width attribute to simulate progress -->
                          <div class="progress-bar progress-bar-aqua" style="width: 20%" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">
                            <span class="sr-only">20% Complete</span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <!-- end task item -->
                  </ul>
                </li>
                <li class="footer" v-if="userInfo.tasks.length > 0">
                  <a href="javascript:;">View all tasks</a>
                </li>
              </ul>
            </li>

            <!-- User Account Menu -->
            <li class="dropdown user user-menu">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
				<!-- hidden-xs hides the username on small devices so only the image appears. -->
                <span class="hidden-xs user-name">{{ demo.displayName }}</span>
				<!-- The user image in the navbar-->
                <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" enable-background="new 0 0 48 48" viewBox="0 0 48 48" width="33px" height="33px" xmlns:xml="http://www.w3.org/XML/1998/namespace" xml:space="preserve" version="1.1"><g><g><circle fill="#ffffff" cx="24" cy="18.796" r="5.084" /><path fill="#ffffff" d="M 30.943 25.688 H 17.056 c -0.904 0 -1.638 0.733 -1.638 1.638 v 10.337 c 2.501 1.554 5.443 2.467 8.605 2.467 c 3.142 0 6.066 -0.902 8.559 -2.439 V 27.326 C 32.582 26.422 31.848 25.688 30.943 25.688 Z" /></g><path fill="#ffffff" d="M 24 0 C 10.745 0 0 10.745 0 24 s 10.745 24 24 24 s 24 -10.745 24 -24 S 37.255 0 24 0 Z M 24.029 43.844 c -11.023 0 -19.959 -8.936 -19.959 -19.959 S 13.006 3.926 24.029 3.926 s 19.959 8.936 19.959 19.959 S 35.052 43.844 24.029 43.844 Z" /></g></svg>
              </a>
              <ul class="dropdown-menu usermenu">
                <li><a href="#" v-on:click="logout()">Logoff</a></li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
	</div>
    </header>
    <!-- Left side column. contains the logo and sidebar -->
    <sidebar :display-name="demo.displayName" :picture-url="demo.avatar" />

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <!-- <h1>{{ $route.meta.description }} -->
<!--           {{$route.name.toUpperCase() }}
          <small>{{ $route.meta.description }}</small> -->
        <!-- </h1>
        <ol class="breadcrumb">
          <li>
            <a href="javascript:;">
              <i class="fa fa-home"></i>Home</a>
          </li>
          <li class="active">{{$route.meta.description.toUpperCase()}}</li>
        </ol> -->
      </section>

      <router-view></router-view>
    </div>
    <!-- /.content-wrapper -->

    <!-- Main Footer -->
    <footer class="main-footer">
      <strong>Copyright &copy; {{year}}
        <a href="https://www.vizeum.com/" target="blank">vizeum</a>.</strong> All rights reserved.
    </footer>
    <simplert :useRadius="true" :useIcon="true" ref="confirmbox"></simplert>
  </div>
  <!-- ./wrapper -->
</template>

<script>

import { mapState } from 'vuex'
import config from '../config'
import Sidebar from './Sidebar'
import Simplert from 'vue2-simplert'
import 'hideseek'
export default {
  name: 'Dash',
  components: {
    Sidebar,
    Simplert
  },
  data: function () {
    return {
      // section: 'Dash',
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      },
      error: ''
    }
  },
  mounted () {
    if ((window.localStorage.getItem('user') === 'null') || window.localStorage.length === 0) {
      this.$router.push('/login')
    }
    this.responsiveRestrictions()
    window.addEventListener('resize', this.responsiveRestrictions)
  },
  computed: {
    ...mapState([
      'userInfo'
    ]),
    demo () {
      // var usern = localStorage.getItem('username')
      return {
        displayName: localStorage.getItem('username'),
        avatar: '/static/img/stock/user.png',
        email: localStorage.getItem('email'),
        randomCard: ''
      }
    }
  },
  methods: {
    changeloading () {
      this.$store.commit('TOGGLE_SEARCHING')
    },
    logout () {
      this.$parent.logout()
    },
    responsiveRestrictions () {
      if (window.innerWidth < 1380) {
        let modelCreatedModal = {
          title: 'Screen resolution is not compatible, please try with higher resolutions',
          message: '',
          type: 'success',
          customCloseBtnClass: 'btn btn-primary'
        }
        this.$refs.confirmbox.openSimplert(modelCreatedModal)
      }
    }
  }
}
</script>

<style lang="scss">
body {
  font-family: Helvetica,Arial,sans-serif;
}
.wrapper {
  min-height: 100vh !important;
}
.wrapper.fixed_layout {
  .main-header {
    position: fixed;
    width: 100%;
  }

  .content-wrapper {
    padding-top: 50px;
    min-height:90vh;
  }

  .main-sidebar {
    position: fixed;
    height: 100vh;
  }
}

.wrapper.hide_logo {
  @media (max-width: 767px) {
    .main-header .logo {
      display: none;
    }
  }
}

.logo-mini,
.logo-lg {
  text-align: left;
}
.user-menu.user {
  > a {
    padding-right: 20px;
    .user-name{
      margin-right: 20px;
    }
    > span, > svg {
        vertical-align: middle;
        display: inline-block;
    }
  }
}

.logo-lg {
  img {
    display: -webkit-inline-box;
    width: 25%;
  }
}
.sidebar-mini.sidebar-collapse .main-sidebar, .left-side {
    padding-top: 64px;
    width: 70px !important;
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
}
.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}
.content-wrapper, .right-side{
  background-color:#fff;
}
.bg-green, .callout.callout-success, .alert-success, .label-success, .modal-success .modal-body {
  background-color:#1bbc9b;
}
.alert-success {
    width: 97.5%;
    margin: 10px auto;
    border-color:#1bbc9b;
}

  .usermenu {
    width: 100% !important;
    background: #000;
    li a{
      color: #fff !important;
      font-weight: bold;
      &:hover {
        background-color: #444;

      }
    }
  }
	.sidebar-mini.sidebar-collapse .main-footer,.sidebar-mini.sidebar-collapse .content-wrapper,.sidebar-mini.sidebar-collapse .right-side{
		margin-left: 70px !important;
	}
	.sidebar-mini.sidebar-collapse .main-header {
	  background-color:#000;
	  .logo{
	    width: auto;
	    height: 32px;
	    margin: 12px 0 12px 18px;
	    padding: 0;
	  }
	  .navbar{
	    margin: 0;
	  }
	}
  h4 small {
  font-size: 60% !important;
}

.excelwrapper {
    float: left;
  }
  .exceltablestyle .htDimmed {
    background-color: #000 !important;
    color: #989595 !important;
    font-weight: bold;
  }
  .exceltablestyle th {
    background-color: #000 !important;
    color: #fff !important;
    font-weight: bold !important;
  }
  td.esheetclass {
    background: #fac600 !important;
  }
  .handsontable thead th.ht__highlight {
    background-color: #000 !important;
    text-align: center !important;
  }
  .handsontable thead th {
    background-color: #000 !important;
    text-align: center !important;
  }
  .handsontable td.esheetclass.htDimmed {
    text-align: left;
  }

  .handsontable td.esheetclass {
    text-align: center;
  }

  .spinner {
    position: fixed;
    left: 0;
    right: auto;
    top: 0;
    z-index: 99999;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.8);
    text-align: center;
    display:none;
  }
//   .spinner > div {
//   width: 18px;
//   height: 18px;
//   background-color: #000;
//   border-radius: 100%;
//   display: inline-block;
//   vertical-align: middle;
//   -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
//   animation: sk-bouncedelay 1.4s infinite ease-in-out both;
// }
// .spinner:before {
//     content: '';
//     width: 1px;
//     height: 100%;
//     display: inline-block;
//     vertical-align: middle;
// }
// canvas {
//   transition: all 0.35s ease-in-out;
// }
// .spinner .bounce1 {
//   -webkit-animation-delay: -0.32s;
//   animation-delay: -0.32s;
// }

// .spinner .bounce2 {
//   -webkit-animation-delay: -0.16s;
//   animation-delay: -0.16s;
// }

// @-webkit-keyframes sk-bouncedelay {
//   0%,
//   80%,
//   100% {
//     -webkit-transform: scale(0);
//   }
//   40% {
//     -webkit-transform: scale(1);
//   }
// }

// @keyframes sk-bouncedelay {
//   0%,
//   80%,
//   100% {
//     -webkit-transform: scale(0);
//     transform: scale(0)
//   }
//   40% {
//     -webkit-transform: scale(1);
//     transform: scale(1);
//   }
// }
section.content {
  min-height: 85vh !important;
}

.loader,
.loader:before,
.loader:after {
  background: #f1b828;
  -webkit-animation: load1 1s infinite ease-in-out;
  animation: load1 1s infinite ease-in-out;
  width: 1em;
  height: 4em;
}
.loader {
  color: #f1b828;
  text-indent: -9999em;
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  font-size: 11px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
.loadingtext {
    color: #fff;
    margin: auto;
    position: absolute;
    top: 130px;
    left: 0;
    bottom: 0;
    right: 0;
    height: 3em;
    font-size: 18px;
}
.loader:before,
.loader:after {
  position: absolute;
  top: 0;
  content: '';
}
.loader:before {
  left: -1.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.loader:after {
  left: 1.5em;
}
@-webkit-keyframes load1 {
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 4em;
  }
  40% {
    box-shadow: 0 -2em;
    height: 5em;
  }
}
@keyframes load1 {
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 4em;
  }
  40% {
    box-shadow: 0 -2em;
    height: 5em;
  }
}
</style>



// WEBPACK FOOTER //
// Dash.vue?748c8d9c